import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { FormOption } from 'src/app/shared/models/form-option.model';
import { CardiovascularFormGroup } from 'src/app/calvin-emr-shared/models/assessments/cardiovascular.model';
import { WnlGroupDirective } from '../wnl/wnl-group.directive';
import { WnlControlDirective } from '../wnl/wnl-control.directive';

@Component({
  selector: 'app-cardiovascular-form',
  templateUrl: './cardiovascular-form.component.html',
  styleUrls: ['./cardiovascular-form.component.scss', '../assessments-tab.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrCheckboxComponent,
    EmrInputComponent,
    WnlGroupDirective,
    WnlControlDirective,
  ],
})
export class CardiovascularFormComponent implements OnInit {

  formGroup = input.required<CardiovascularFormGroup>();

  ngOnInit(): void {
    // Clear the "Other Rhythm" control if the user switches from "Other" to a different option
    this.formGroup().controls.rhythm.valueChanges.subscribe((value: string | null) => {
      if (value != 'Other') {
        this.formGroup().controls.rhythmOther.setValue('', { emitEvent: false });
      }
    });

    // this.pacemakerFormControl.valueChanges.subscribe(value => {
    //   console.log('Pacemaker Value: ', value);
    // });

    // this.pacemakerCommentFormControl.valueChanges.subscribe(value => {
    //   console.log('Pacemaker Comment Value: ', value);
    // });
  }

  reset() {
    this.formGroup().enable({ emitEvent: false });
  }

  get isOtherRhythm() {
    return this.formGroup().controls.rhythm.value === 'Other';
  }

  get isPaceMaker(): boolean {
    return !!this.formGroup().controls.pacemaker.value;
  }

  heartTonesOptions = [
    new FormOption('Murmur'),
    new FormOption('Gallup'),
    new FormOption('WNL'),
  ];

  rhythmOptions = [
    new FormOption('Atrial Fibrillation'),
    new FormOption("PVC's"),
    new FormOption("PAC's"),
    new FormOption('SVT'),
    new FormOption('Atrial Flutter'),
    new FormOption('Other'),
    new FormOption('NSR'),
  ];

  pittingEdemaOptions = [
    new FormOption('1+'),
    new FormOption('2+'),
    new FormOption('3+'),
    new FormOption('4+'),
    new FormOption('WNL'),
  ];

  generalizedPerfusionOptions = [
    new FormOption('Cold'),
    new FormOption('Pale'),
    new FormOption('Cyanotic'),
    new FormOption('Palpitations'),
    new FormOption('WNL'),
  ];

  extremityOptions = [
    new FormOption('RUE'),
    new FormOption('RLE'),
    new FormOption('LUE'),
    new FormOption('LLE'),
  ];

  pulseOptions = [
    new FormOption('+3 strong'),
    new FormOption('+2 normal'),
    new FormOption('+1 weak, thready'),
    new FormOption('0 absent'),
  ];
}